


























import ReportedIssuesGame from './scripts';

export default ReportedIssuesGame;
